var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurgerMenuMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85712 11.7589H12.9653V10.616H2.85712V11.7589ZM2.85712 4.90173V6.04459H12.9653V4.90173H2.85712ZM2.85712 8.90173H12.9653V7.75888H2.85712V8.90173Z",
    fill: "#5932EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuMobile);
export default __webpack_public_path__ + "static/media/burger_menu_mobile.c4d358b154a716436193bce3f4241fb2.svg";
export { ForwardRef as ReactComponent };